export default {
  LIST_SEARCH_CAMPAIGN: "LIST_SEARCH_CAMPAIGN",
  LIST_TOP_KEYWORD: "LIST_TOP_KEYWORD",
  LIST_DISPLAY_CAMPAIGN: "LIST_DISPLAY_CAMPAIGN",
  LIST_TOP_AUDIENCE: "LIST_TOP_AUDIENCE",
  LIST_TOP_PLACEMENT: "LIST_TOP_PLACEMENT",
};
